import { render, staticRenderFns } from "./MerchantCompaniesList.vue?vue&type=template&id=c0fcb7c8&scoped=true"
import script from "./MerchantCompaniesList.vue?vue&type=script&lang=js"
export * from "./MerchantCompaniesList.vue?vue&type=script&lang=js"
import style0 from "./MerchantCompaniesList.vue?vue&type=style&index=0&id=c0fcb7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fcb7c8",
  null
  
)

export default component.exports